export const images = {
    logo: require("../assets/images/logo01.png"),
    collapseLogo: require("../assets/images/collapse_logo_01.png"),
    bodyBuilding: require("../assets/images/plans/body-building.jpg"),
    dumbbellPlan: require("../assets/images/plans/dumbbell-excercise.jpg"),
    homeBodyBuilding: require("../assets/images/plans/home-body-building.jpg"),
    loseFat: require("../assets/images/plans/lose-fat.jpg"),
    winterShred: require("../assets/images/plans/winter-shred.jpg"),
}
 
export const websiteImages = {
    headerBg: require("../assets/images/websiteImages/Header-bg.png"),
    subcriptionBg: require("../assets/images/websiteImages/Subscription-Bg.jpg"),
    websiteLogo: require("../assets/images/websiteImages/website-logo.png"),
    addressIcon: require("../assets/images/websiteImages/Address.png"),
    emailIcon: require("../assets/images/websiteImages/Mail.png"),
    callIcon: require("../assets/images/websiteImages/Call.png"),
    timeIcon: require("../assets/images/websiteImages/Time.png"),
    dumbbellMen: require("../assets/images/websiteImages/Dumbbells-Men.png"),
    workoutGirl: require("../assets/images/websiteImages/WorkoutGirl-Bg.png"),
    beforeAfterImage: require("../assets/images/websiteImages/Before-After-Image.jpg"),
    goalAndLifestyleImage: require("../assets/images/websiteImages/Goal-Lifestyle.png"),
    vectorReviewImage: require("../assets/images/websiteImages/Vector02.png"),
    vectorGoalImage: require("../assets/images/websiteImages/Vector01.png"),
    quoteIconImage: require("../assets/images/websiteImages/Quote-Icon.png"),
}
 
export const trasformationImages = {
    transformation01 : require("../assets/images/Trasformation/Trasformation-01.png"),
    transformation02 : require("../assets/images/Trasformation/Trasformation-02.png"),
    transformation03 : require("../assets/images/Trasformation/Trasformation-03.png"),
    transformation04 : require("../assets/images/Trasformation/Trasformation-04.png"),
    transformation05 : require("../assets/images/Trasformation/Trasformation-05.png"),
    transformation06 : require("../assets/images/Trasformation/Trasformation-06.png"),
    transformation07 : require("../assets/images/Trasformation/Trasformation-07.png"),
    transformation08 : require("../assets/images/Trasformation/Trasformation-08.png"),
    transformation007 : require("../assets/images/Trasformation/Trasformation-007.png"),
    transformation008 : require("../assets/images/Trasformation/Trasformation-008.png"),
}
 
 
export const fitnessHeroImages = {
    fitnesssHero01 : require("../assets/images/Fitness-Hero/Fitness_Hero_Banner_01.png"),
    fitnesssHero02 : require("../assets/images/Fitness-Hero/Fitness_Hero_Banner_02.png"),
    fitnesssHero03 : require("../assets/images/Fitness-Hero/Fitness_Hero_Banner_03.png"),
    fitnesssHero04 : require("../assets/images/Fitness-Hero/Fitness_Hero_Banner_04.png"),
    fitnesssHero05 : require("../assets/images/Fitness-Hero/Fitness_Hero_Banner_05.png"),
    fitnesssHero06 : require("../assets/images/Fitness-Hero/Fitness_Hero_Banner_06.png"),
    fitnesssHero07 : require("../assets/images/Fitness-Hero/Fitness_Hero_Banner_07.png"),
    fitnesssHero08 : require("../assets/images/Fitness-Hero/Fitness_Hero_Banner_08.png"),
    fitnesssHero09 : require("../assets/images/Fitness-Hero/Fitness_Hero_Banner_09.png"),
    fitnesssHero10 : require("../assets/images/Fitness-Hero/Fitness_Hero_Banner_10.png"),
    fitnesssHero11 : require("../assets/images/Fitness-Hero/Fitness_Hero_Banner_11.png"),
    fitnesssHero12 : require("../assets/images/Fitness-Hero/Fitness_Hero_Banner_12.png"),
}